import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  rounded: {
    borderColor: custom.grey[14],
    borderRadius: 100,
    padding: '11px 16px',
    lineHeight: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    color: custom.grey[3],
    fontSize: 16,
    fontWeight: 600,
  },
}));
